export const checkIsValidJSON = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};

/**
 * Тема, уже применённая к документу. Атрибут `data-theme` синхронно ставит
 * пре-бут-скрипт в public/index.html (из localStorage 'native-theme' /
 * prefers-color-scheme) ДО загрузки бандла, поэтому читать его безопасно
 * на этапе инициализации стора.
 *
 * Нужно, чтобы antd стартовал в той же теме, что и CSS-переменные: иначе до
 * прихода `init` от нативы (а в iframe без моста — вообще никогда) antd
 * остаётся светлым поверх тёмной палитры, и поповеры/шапки таблиц выходят
 * белыми со светлым текстом.
 */
export const getDocumentTheme = (): 'light' | 'dark' => {
  try {
    return document.documentElement.getAttribute('data-theme') === 'dark'
      ? 'dark'
      : 'light';
  } catch {
    return 'light';
  }
};

export const safeLocalStorage = {
  get: (key: string): string | null => {
    try {
      return typeof window !== 'undefined' ? localStorage.getItem(key) : null;
    } catch {
      return null;
    }
  },
  set: (key: string, value: string): void => {
    try {
      if (typeof window !== 'undefined') localStorage.setItem(key, value);
    } catch (error) {
      console.error(error);
    }
  },
  remove: (key: string): void => {
    try {
      if (typeof window !== 'undefined') localStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  }
};
